import { render } from "./composeVoice.vue?vue&type=template&id=6e332a80&scoped=true"
import script from "./composeVoice.vue?vue&type=script&lang=js"
export * from "./composeVoice.vue?vue&type=script&lang=js"

import "./composeVoice.vue?vue&type=style&index=0&id=6e332a80&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e332a80"]])

export default __exports__